import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./views/routes";
import * as serviceWorker from "./serviceWorker";
import intl from "react-intl-universal";
import fr from "i18n/fr.js";
import en from "i18n/en.js";
import ar from "i18n/ar.js";

let lang =
  (navigator.languages && navigator.languages[0]) || navigator.language;

let langUse: string;
if (lang.split("-")[0].toLowerCase() === "ar") {
  document.body.style.direction = "rtl";
  langUse = "ar";
} else if (lang.split("-")[0].toLowerCase() === "fr") {
  document.body.style.direction = "ltr";
  langUse = "fr";
} else {
  document.body.style.direction = "ltr";
  langUse = "en";
}

intl.init({
  currentLocale: langUse,
  locales: {
    fr,
    en,
    ar
  },
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
